__turbopack_context__.v({
  "contact-content": "_9XLa0G_contact-content",
  "contact-info": "_9XLa0G_contact-info",
  "header": "_9XLa0G_header",
  "info": "_9XLa0G_info",
  "team": "_9XLa0G_team",
});
